import getConnections from "../../helpers/getConnections";
import useAccount from "../../settings/account/hooks/useAccount";
import { usePaymentApprovals } from "../../settings/paymentConnections/approvalsPayments/hooks/usePaymentApprovals";

export default function usePaymentsEnabled() {
    const { account, isLoading } = useAccount();
    const { approvals, isLoading: approvalsLoading } = usePaymentApprovals();

    if (isLoading || approvalsLoading) {
        return true; // hide the link while loading
    }

    if (!account) {
        return false;
    }

    const numEnabledConnections = getConnections(account, "enabled").length;
    const hasActiveApproval = approvals.some(
        (approval) => approval.case_status === "ACTIVE",
    );

    return (
        account.account_id?.endsWith("00000000") ||
        account.account_id?.endsWith("00000") ||
        numEnabledConnections > 0 ||
        hasActiveApproval
    );
}
